/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-jobs"]';

/**
 * Friendation component
 */
export const blockJobs = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    /** Some {@link filterItems} can toggle some {@link items} */
    const handleFilters = () => {
      /** Filters */
      const filterItems = <HTMLInputElement[]>(
        Array.from(component.querySelectorAll('input[type="radio"]'))
      );
      if (!filterItems.length) return;

      /** Items to filter */
      const items = <HTMLLIElement[]>(
        Array.from(component.querySelectorAll('.listItem'))
      );

      /**
       * Find all {@link items} that match a {@link filter}
       * @param filter Any filter value
       * @returns Filtered items
       */
      const itemsForFilter = (filter?: string) => {
        if (!filter) return;
        return items.filter((x) => x.getAttribute('data-category') === filter);
      };

      /**
       * Find the currently active filter in {@link filterItems}
       * @returns The current filter value
       */
      const currentFilterValue = () => filterItems.find((x) => x.checked).value;

      /** Filters were changed: get the current state and react */
      const onChange = () => {
        // Show target items for current filter
        const filter = currentFilterValue();
        if (filter.length) {
          // hide all items
          items.forEach((x) => (x.inert = true));

          itemsForFilter(filter)?.forEach((x) => (x.inert = false));
        } else {
          // show all items
          items.forEach((x) => (x.inert = false));
        }
      };

      filterItems.forEach((filterItem) => {
        filterItem.addEventListener('change', onChange.bind(this));

        /**
         * Matches for {@link filterItem}
         */
        const results = itemsForFilter(filterItem.value);

        if (filterItem.value && !results.length) {
          filterItem.parentElement.remove();
        }
      });
    };

    handleFilters();
  });
};
